import { joinParts } from './utils'

export const search = {
  find: () => joinParts('search', 'find'),

  findCities: (name: string) => `${joinParts('cities', 'find')}?name=${name}`,

  findCountries: (name: string) => `${joinParts('countries', 'find')}?name=${name}`,
}
